<div id="content-wrapper">
    <div class="container mx-auto" style="max-width: 1300px" *ngIf="!isJobMatchLoading && !isOutreachCompleted">
        <div class="row">
            <div class="col-xs-12">
                <div class="row">
                    <div class="main-box clearfix p-4">
                        <div class="col-xs-12">
                            <p class="mb-3 outreach-heading">Hi, <b>{{outreachObject.candidateName}},</b></p>
                            <p>We are excited to let you know that there {{(outreachObject.jobMatches && outreachObject.jobMatches.length == 0) ? 'is an opportunity' : 'are some opportunities'}} that match your
                                profile at <b>{{(outreachObject.jobMatches && outreachObject.jobMatches.length > 0) ? outreachObject.jobMatches[0].company : companyName}}</b>. The profile we have of you was obtained on <b>{{outreachObject.profileCreationOrModifiedDate | fourDotFiveTimeStampFormatPipe}}</b>. Please view your profile <a (click)="openModal(candidateId, candidateResumeTemplate, 'resume')">here</a>.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row main-box p-4" *ngIf="!isSingleResumeUploadedInPreviousSession">
            <div class="col-xs-12">
                <div class="row mx-0">
                    <div class="main-box clearfix">
                        <div class="col-xs-12 px-3 py-1" *ngIf="!isSingleResumeUploadDone">
                            <p class="outreach-heading pt-2">You match <strong>{{outreachObject.jobMatches.length}}</strong> <span>{{outreachObject.jobMatches.length == 1 ? ' Job ' : ' Jobs '}}</span> based on the
                                profile we have on file.
                            </p>
                            <p>Before that, If you believe that you have an updated resume, please feel free to upload it here. This
                                is an opportunity (1 upload only) to update your records now.</p>
                        </div>
                        <div class="col-xs-12" *ngIf="isSingleResumeUploadDone">
                            <h4><strong>Thank you for uploading your resume.</strong></h4>
                            <p>Your latest profile has been updated as of <strong>{{outreachObject.profileCreationOrModifiedDate | fourDotFiveTimeStampFormatPipe}}</strong>. The Job Matches table has been updated with opportunities that match your profile based on your latest resume.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isSingleResumeUploadDone" class="col-xs-12" [ngClass]="{'disable-element': isSingleResumeUploadDone}">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="main-box clearfix" style="min-height: 200px;">
                            <div class="main-box-body clearfix col-lg-10 col-lg-offset-1" style="margin-top: 60px;">
                                <div>
                                    <form name="outreachEmailResumeUploadDropzone"
                                        id="outreachEmailResumeUploadDropzone" class="dropzone dz-clickable" action=""
                                        enctype="multipart/form-data"
                                        [dropzone]="dropzoneConfig" (addedFile)="onResumeFileAdded()"
                                        (removedFile)="onResumeFileRemoved()" (sending)="onResumeFileSending($event)"
                                        (success)="onResumeFileSuccess($event)" (error)="onResumeFileError($event)">
                                        <div class="dz-a dz-default dz-message">
                                            <span>
                                                <h3>Drop files here to upload</h3>(or click)
                                            </span>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="row buttonrow" style="margin-bottom: 200px">
                                <div class="col-xs-12 col-sm-offset-4 col-sm-4">
                                    <button type="button" class="btn btn-success col-xs-12" id="uploadFile"
                                        (click)="uploadResumes('screen')" [disabled]="disableUploadButtonFlag">
                                        <i class="fa fa-upload mr-2"></i>
                                        <span *ngIf="!fileUploadInProgressFlag">Upload </span><span
                                            *ngIf="fileUploadInProgressFlag">Uploading... </span> Resume
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 px-0">
                <div class="slide-main-container">
                    <div class="container slide-main-animation">
                        <div class="row main-box p-4">
                            <div class="col-xs-12">
                                <h4 class="mb-4"><b>Job Matches</b></h4>
                            </div>
                            <div class="col-xs-12 mb-3">
                                <ng-container *ngTemplateOutlet="jobMatchTableTemplate;
                                  context: {
                                    outreachObject: outreachObject,
                                    isStaffingCompany: isStaffingCompany,
                                    jobTypeList: jobTypeList,
                                    salaryDurationOptions: salaryDurationOptions,
                                    isModal: false
                                  }">
                                </ng-container>
                            </div>

                            <div class="col-xs-12 mt-4">
                                <div class="">
                                    <div>
                                        <h4 *ngIf="isCandidateContactDetailsMissing || isCandidateAdditionalContactDetailsMissing" class="candidate-fill-out-message red mb-3 font-bold">It is important to fill out your Contact Details and
                                            Additional Details to accurately see the Job(s) that match your profile based on your information.</h4>
                                        <h4 *ngIf="!isCandidateContactDetailsMissing && !isCandidateAdditionalContactDetailsMissing && candidateContactData.contactOrAdditionalDetailsFromOutreachDraft" class="candidate-fill-out-message+ mb-3 font-bold badge badge-warning">Information entered by you is in Draft mode</h4>
                                    </div>
                                    <div class="main-box">
                                        <tabset>
                                            <!-- Contact Details -->
                                            <tab>
                                                <ng-template tabHeading>
                                                    <span>Contact details</span>
                                                    <span *ngIf="isCandidateContactDetailsMissing" class="fa fa-exclamation-circle red ml-2"
                                                        tooltip="Complete Missing Information" placement="top" container="body">
                                                    </span>
                                                </ng-template>
                                                <div class="px-4 ml-2">
                                                    <div class="d-flex justify-content-end align-items-center pl-4">
                                                        <div class="edit-link pull-right position-relative pr-2" style="top: 12px;"
                                                            (click)="openModal(candidateId, candidateContactTemplate, 'candidateContact')"><i
                                                                class="fas fa-pen mr-2 text-primary"></i>EDIT</div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <div class="col-md-4">
                                                            <p class="label-text">First Name</p>
                                                            <p class="value-text">{{(candidate.firstName && candidate.firstName != "") ? candidate.firstName
                                                                : "-"}}</p>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <p class="label-text">Last Name</p>
                                                            <p class="value-text">{{(candidate.lastName && candidate.lastName != "") ? candidate.lastName :
                                                                "-"}}</p>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <p class="label-text">Phone Number</p>
                                                            <p class="value-text">{{(candidate.mobilePhone && candidate.mobilePhone) != "" ?
                                                                candidate.mobilePhone :
                                                                "-"}}</p>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <p class="label-text">Email</p>
                                                            <p class="value-text">{{(candidate.email && candidate.email != "" ? candidate.email : "-")}}</p>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <p class="label-text">Location</p>
                                                            <p class="value-text">{{candidate.location}}</p>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <p class="label-text">Address</p>
                                                            <p class="value-text pr-3">
                                                                {{candidate.combinedAddress}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </tab>
                                            <!-- Additional Contact Details -->
                                            <tab>
                                                <ng-template tabHeading>
                                                    <span>Additional Details</span>
                                                    <span *ngIf="isCandidateAdditionalContactDetailsMissing" class="fa fa-exclamation-circle red ml-2"
                                                        tooltip="Complete Missing Information" placement="top" container="body">
                                                    </span>
                                                </ng-template>
                                                <div class="px-4 ml-2 pb-4">
                                                    <div class="d-flex justify-content-end align-items-center">
                                                        <div class="edit-link pull-right position-relative pr-2" style="top: 12px;"
                                                            (click)="openModal(candidateId, candidateAdditionalContactTemplate, 'additionalCandidateContact')">
                                                            <i class="fas fa-pen mr-2 text-primary"></i>EDIT
                                                        </div>
                                                    </div>
                                    
                                                    <div class="row mt-2">
                                                        <div class="col-sm-12 col-md-4">
                                                            <p class="label-text">
                                                                <i class="fas fa-dollar-sign"></i>
                                                                <span class="pl-2 font-weight-bold">Preferred Job Type</span>
                                                            </p>
                                                            <p class="px-4 value-text">{{ candidate.displayAdditionalDetails ? candidate.displayAdditionalDetails.jobTypes : '-' }}</p>
                                                        </div>
                                                        <div class="col-sm-12 col-md-4">
                                                            <p class="label-text">
                                                                <i class="fas fa-dollar-sign"></i>
                                                                <span class="pl-2 font-weight-bold">Salary/Rate</span>
                                                            </p>
                                                            <p class="px-4 value-text" *ngIf="candidate.displayAdditionalDetails && candidate.displayAdditionalDetails.jobTypes == '-'">-</p>
                                                            <p class="px-4 mb-1 value-text" *ngIf="candidate.displayAdditionalDetails && candidate.displayAdditionalDetails.salary != '-'">
                                                                <b>Salary:</b> {{ candidate.displayAdditionalDetails.salary }}</p>
                                                            <p class="px-4 value-text" *ngIf="candidate.displayAdditionalDetails && candidate.displayAdditionalDetails.rate != '-'"><b>Rate:</b>
                                                                {{ candidate.displayAdditionalDetails.rate }}</p>
                                                        </div>
                                                        <div class="col-sm-12 col-md-4">
                                                            <p class="label-text">
                                                                <i class="fas fa-award"></i>
                                                                <span class="pl-2 font-weight-bold">Employment Eligibility</span>
                                                            </p>
                                                            <p class="px-4 ml-1 value-text">{{ candidate.displayAdditionalDetails ? candidate.displayAdditionalDetails.sponsorships : '-' }}</p>
                                                        </div>
                                                    </div>
                                    
                                                    <div class="row mt-2">
                                                        <div class="col-sm-12 col-md-4">
                                                            <p class="label-text">
                                                                <i class="far fa-building"></i>
                                                                <span class="pl-2 font-weight-bold">Preferred Work Locations</span>
                                                            </p>
                                                            <p class="px-4 ml-1 mb-3 value-text">{{ candidate.displayAdditionalDetails ? candidate.displayAdditionalDetails.worklocations : '-' }}</p>
                                                            <p class="px-4 ml-1 value-text"><b>Willing to Relocate: </b>{{
                                                                candidate.displayAdditionalDetails ? candidate.displayAdditionalDetails.willingToRelocate  : '-' }}</p>
                                                        </div>
                                                        <div class="col-sm-12 col-md-4">
                                                            <p class="label-text">
                                                                <i class="fa fa-link"></i>
                                                                <span class="pl-2 font-weight-bold">Additional URL's</span>
                                                            </p>
                                                            <p class="px-4 value-text"
                                                                *ngIf="candidate.displayAdditionalDetails && candidate.displayAdditionalDetails.additionalUrls.length == 0">-</p>
                                                            <div class="px-4 ml-1 value-text"
                                                                *ngIf="candidate.displayAdditionalDetails && candidate.displayAdditionalDetails.additionalUrls.length > 0">
                                                                <span *ngFor="let url of candidate.displayAdditionalDetails.additionalUrls"
                                                                    class="d-block mb-1">
                                                                    <b>{{ url.urlType }}:</b> {{ url.urlLink }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-12 col-md-4">
                                                            <p class="label-text">
                                                                <span class="pl-4 font-weight-bold">Additional Information</span>
                                                            </p>
                                                            <p class="px-4 value-text">{{ candidate.displayAdditionalDetails ? candidate.displayAdditionalDetails.additionalInformation : '-' }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </tab>
                                        </tabset>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 px-0">
                                <div class="col-xs-12">
                                    <h4 class="mb-4"><b>Outreach Feedback</b><span class="ml-2 font-bold badge badge-warning" *ngIf="isOutreachQuestionsSavedInDraft">Information entered by you is in Draft mode</span></h4>
                                </div>
                                <div class="col-xs-12 px-0 pl-2">
                                    <app-feedback-execution
                                        [jobMatchId]="jobMatchId"
                                        [candidateId]="candidateId"
                                        (completeFeedbackCallback)="saveCallback()"
                                        (saveCallback)="refreshCallback()"
                                        [feedbackType]="'Outreach'"
                                        [externalCommentRequired]="false"
                                        [loginRequired]="false"
                                        [feedbackReadOnly]="false"
                                        [outreachData]="outreachData"
                                        [activeOutreachFeedbackQuestionsList]="activeOutreachFeedbackClientsQuestionsList"
                                        [context]="'outreach'"
                                        [disableFeedbackQuestions]="isCandidateContactDetailsMissing || isCandidateAdditionalContactDetailsMissing || isAllJobmatchesInterestedOrNotInterestedOrMaybeDisabled"
                                        [isFeedbackTabActive]="isFeedbackTabActive">
                                    </app-feedback-execution>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
        <div class="row main-box p-4">
            <div class="py-2 pull-right">
                <button class="btn btn-primary" (click)="outreachEmailSave('save')">Save</button>
                <button class="btn btn-primary ml-2" (click)="outreachEmailSave('complete')">Submit</button>
            </div>
        </div>
    </div>
    <div class="container mx-auto" style="max-width: 1300px" *ngIf="isJobMatchLoading">
        <div class="row main-box clearfix p-4">
            <div class="col-xs-12">
                <div class="skeleton-heading width-25 skeleton-loading mb-3"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading mb-2"></div>
                <div class="skeleton-paragraph width-75 skeleton-loading"></div>
            </div>
        </div>
        <div class="row main-box p-4">
            <div class="col-xs-12">
                <div class="skeleton-heading width-25 skeleton-loading mb-4"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading mb-3"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading mb-3" *ngFor="let row of [0, 1, 2]"></div>
            </div>
            <div class="col-xs-12 mt-4">
                <div class="skeleton-heading width-25 skeleton-loading mb-4"></div>
                <div class="row">
                    <div class="col-md-4 mb-4" *ngFor="let field of [0, 1, 2, 3, 4, 5]">
                        <div class="skeleton-paragraph width-50 skeleton-loading mb-2"></div>
                        <div class="skeleton-paragraph width-75 skeleton-loading"></div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 mt-2">
                <div class="skeleton-heading width-25 skeleton-loading mb-4"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading mb-3" *ngFor="let row of [0, 1, 2]"></div>
            </div>
        </div>
    </div>
    <div class="container mx-auto" style="height: 82vh" *ngIf="!isJobMatchLoading && isOutreachCompleted">
        <div class="d-flex justify-content-center align-items-center" style="height: 75vh;">
            <div class="text-center p-5 shadow-lg success-card">
    
                <div class="mb-3">
                    <i class="fa fa-check-circle" style="font-size: 60px; color: #28a745;"></i>
                </div>
    
                <h4 class="font-bold mb-5">
                    Outreach Submitted
                </h4>
    
                <p class="lead mb-0" style="font-size: 17px; line-height: 1.5;">
                    You have successfully submitted your outreach information. <br />
                    <span *ngIf="!outreachResultedInNoJobMatches">
                        Someone from <strong>{{companyName}}</strong> will get back to you shortly.
                    </span>
                    <span *ngIf="outreachResultedInNoJobMatches">
                        <b>Don't worry! We still have your profile and preference information and will use it to provide better matches to future job opportunities.</b>
                    </span>
                </p>
            </div>
        </div>

    </div>
</div>

<ng-template #jobProfileTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="closeModal('jobProfile')">×</button>
        <h4 class="modal-title wrap-text-in ng-binding">Job Profile</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <app-job-profile [jobId]="jobModalId" context="outreach"></app-job-profile>
        </div>
    </div>
</ng-template>

<ng-template #candidateResumeTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="closeModal('resume')">×</button>
        <h4 class="modal-title wrap-text-in ng-binding">Resume PDF</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="row">
                <div class="col-xs-12 mb-3" *ngIf="!isSingleResumeUploadedInPreviousSession">
                    <button class="btn btn-primary pull-right mr-4" [disabled]="isSingleResumeUploadDone" (click)="openModal(candidateId, resumeUploadTemplate, 'upload')">Upload</button>
                </div>
                <div class="col-xs-12">
                    <object [data]="resumepdfViewUrl" type="application/pdf" style="width:100%; height:100vh;">
                        <embed [src]="resumepdfUrl" type="application/pdf" width="100%" height="500px" />
                    </object>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #resumeUploadTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="closeModal('upload')">×</button>
        <h4 class="modal-title wrap-text-in ng-binding">Upload Resume</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12" [ngClass]="{'disable-element': isSingleResumeUploadDone}">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="main-box clearfix" style="min-height: 200px;">
                            <div class="main-box-body clearfix col-lg-10 col-lg-offset-1" style="margin-top: 60px;">
                                <div>
                                    <form name="outreachEmailResumeUploadDropzoneModal"
                                        id="outreachEmailResumeUploadDropzoneModal" class="dropzone dz-clickable" action=""
                                        enctype="multipart/form-data"
                                        [dropzone]="dropzoneConfig" (addedFile)="onResumeFileAdded()"
                                        (removedFile)="onResumeFileRemoved()" (sending)="onResumeFileSending($event)"
                                        (success)="onResumeFileSuccess($event)" (error)="onResumeFileError($event)">
                                        <div class="dz-a dz-default dz-message">
                                            <span>
                                                <h3>Drop files here to upload</h3>(or click)
                                            </span>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="row buttonrow" style="margin-bottom: 200px">
                                <div class="col-xs-12 col-sm-offset-4 col-sm-4">
                                    <button type="button" class="btn btn-success col-xs-12" id="uploadFile"
                                        (click)="uploadResumes('modal')" [disabled]="disableUploadButtonFlag">
                                        <i class="fa fa-upload mr-2"></i>
                                        <span *ngIf="!fileUploadInProgressFlag">Upload </span><span
                                            *ngIf="fileUploadInProgressFlag">Uploading... </span> Resume
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #candidateContactTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="closeModal('candidateContact')">×</button>
        <h4 class="modal-title wrap-text-in ng-binding"><b>Contact Details</b></h4>
    </div>

    <div class="modal-body">
        <div class="row main-box m-3 px-3 py-4">
            <app-add-edit-candidate-contact-one *ngIf="!loadingFlag" context="outreach" [candidateId]="candidateId"
                [contactData]="candidateContactData" (saveCallback)="saveCallback('contact')" (cancelCallback)="closeModal('candidateContact')">
            </app-add-edit-candidate-contact-one>   
        </div>
    </div>
</ng-template>

<ng-template #candidateAdditionalContactTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="closeModal('additionalCandidateContact')">×</button>
        <h4 class="modal-title wrap-text-in ng-binding"><b>Additional Details</b></h4>
    </div>

    <div class="modal-body">
        <div class="row px-3">
            <app-candidate-additional-details *ngIf="!loadingFlag" context="outreach" [additionalDetails]="candidate.candidateAdditionalDetails" 
                [showSalary]="true" (refreshCandidateProfileCallback)="saveCallback('additional contact')" (cancelCallback)="closeModal('additionalCandidateContact')">
            </app-candidate-additional-details>
        </div>
    </div>
</ng-template>

<ng-template #jobMatchTableTemplate let-outreachObject="outreachObject" let-isStaffingCompany="isStaffingCompany"
    let-jobTypeList="jobTypeList" let-salaryDurationOptions="salaryDurationOptions" let-isModal="isModal">

    <div class="col-xs-12 px-0 outreach-job-match-table">
        <table width="100%" class="table-bordered feedback-requisitions-table">
            <thead>
                <tr style="line-height: 1.5; background-color: #03a9f426;">
                    <th>Req#</th>
                    <th>Title</th>
                    <th>{{isStaffingCompany ? 'Client @ Location' : 'Corporate/BU @ Location'}}</th>
                    <th>Match</th>
                    <th>Missing/Non matched information</th>
                    <th *ngIf="!isModal">Interested/Not Interested/Maybe</th>
                    <th *ngIf="!isModal">Outreach Status</th>
                    <th *ngIf="!isModal">Days since Outreach</th>
                </tr>
            </thead>

            <tbody *ngIf="outreachObject.jobMatches && outreachObject.jobMatches.length > 0">
                <tr *ngFor="let jobMatch of outreachObject.jobMatches; let i = index"
                    [ngClass]="{ 'disablescreen row-disabled': !jobMatch.jobMatchActive || jobMatch.noLongerMatch }">

                    <td><span>{{ jobMatch.requisitionNumber }}</span></td>

                    <td>
                        <a class="cursor-pointer" (click)="openModal(jobMatch.jobId, jobProfileTemplate, 'jobProfile')">
                            {{ jobMatch.title }}
                        </a>

                        <div class="mt-3 pl-3">
                            <app-candidate-card-icons context="candidateOutreach" [candidate]="jobMatch"
                                [requisitionSponsorships]="jobMatch.missingOrNonMatchedInfo.requisitionSponsorships"
                                [candidateAdditionalDetails]="jobMatch.missingOrNonMatchedInfo"
                                [candidateSalaryDurationOptions]="salaryDurationOptions" [jobTypeList]="jobTypeList"
                                [hideSalaryIcon]="jobMatch.missingOrNonMatchedInfo ? (jobMatch.missingOrNonMatchedInfo.requisitionJobType === 'CONTRACTOR' || jobMatch.missingOrNonMatchedInfo.requisitionJobType === 'CONTRACTTOHIRE') : false">
                            </app-candidate-card-icons>
                        </div>

                        <div class="outreach-job-match-detail-container">
                            <div class="outreach-job-match-detail-row">
                                <span class="outreach-job-match-detail-heading">Preferred Job Type:</span>
                                <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.preferredJobType}}</span>
                            </div>
                            <div class="outreach-job-match-detail-row"
                                    *ngIf="jobMatch.missingOrNonMatchedInfo ? (jobMatch.missingOrNonMatchedInfo.requisitionJobType !== 'CONTRACTOR' && jobMatch.missingOrNonMatchedInfo.requisitionJobType !== 'CONTRACTTOHIRE') : false">
                                <span class="outreach-job-match-detail-heading">Salary:</span>
                                <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.salary}}</span>
                            </div>
                            <div class="outreach-job-match-detail-row">
                                <span class="outreach-job-match-detail-heading">Sponsorship:</span>
                                <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.sponsorships}}</span>
                            </div>
                            <div class="outreach-job-match-detail-row">
                                <span class="outreach-job-match-detail-heading">Work Location:</span>
                                <span class="outreach-job-match-detail-value">{{jobMatch.jobDetails.workLocations}}</span>
                            </div>
                        </div>
                    </td>

                    <td>{{jobMatch.companyLocationLabel}}</td>
                    <td>{{jobMatch.candidateMatch}}</td>
                    <!-- <td *ngIf="isModal"><span tooltip="Score" placement="top" container="body">{{jobMatch.score}}</span>
                        / <span tooltip="Threshold Score" placement="top"
                            container="body">{{jobMatch.thresholdScore}}</span>
                    </td> -->

                    <td class="px-2">
                        <ul *ngIf="jobMatch.missingOrNonMatched.length > 0" class="list-unstyled">
                            <li *ngFor="let missingInfo of jobMatch.missingOrNonMatched; let i = index">
                                <span>{{ i + 1 }}. {{ missingInfo }}</span>
                                <span class="fa fa-exclamation-circle red ml-2" tooltip="Missing Information"
                                    placement="top" container="body" style="font-size: 12px;"></span>
                            </li>
                        </ul>
                        <p *ngIf="!jobMatch.missingOrNonMatched || jobMatch.missingOrNonMatched.length == 0"
                            class="d-flex justify-content-center">-</p>
                    </td>

                    <td *ngIf="!isModal" [ngClass]="{ 'disablescreen row-disabled': isCandidateContactDetailsMissing || isCandidateAdditionalContactDetailsMissing || jobMatch.isNoLongerMatch}">
                        <div class="d-flex flex-column align-items-baseline form-group mb-0 ml-3"
                            [ngClass]="{ 'has-error': !jobMatch.isValid }">

                            <div class="radio" style="display: inline;">
                                <input type="radio" [name]="'interestedOrNotInterested_' + i" [id]="'interested_' + i"
                                    value="INTERESTED" [(ngModel)]="jobMatch.outreachStatus"
                                    (change)="jobMatchOutreachStatusChanged(jobMatch)">
                                <label [for]="'interested_' + i" class="control-label list-inline">Interested</label>
                            </div>

                            <div class="radio" style="display: inline;">
                                <input type="radio" [name]="'interestedOrNotInterested_' + i"
                                    [id]="'notInterested_' + i" value="NOT_INTERESTED"
                                    [(ngModel)]="jobMatch.outreachStatus"
                                    (change)="jobMatchOutreachStatusChanged(jobMatch)">
                                <label [for]="'notInterested_' + i" class="control-label list-inline">Not
                                    Interested</label>
                            </div>

                            <div class="radio" style="display: inline;">
                                <input type="radio" [name]="'interestedOrNotInterested_' + i" [id]="'mayBe_' + i"
                                    value="MAY_BE" [(ngModel)]="jobMatch.outreachStatus"
                                    (change)="jobMatchOutreachStatusChanged(jobMatch)">
                                <label [for]="'mayBe_' + i" class="control-label list-inline">Maybe</label>
                            </div>

                        </div>
                    </td>

                    <td *ngIf="!isModal">
                        {{ jobMatch.formattedOutreachStatus == 'Outreach Sent'
                        ? 'Outreach Received'
                        : jobMatch.formattedOutreachStatus }}
                    </td>
                    <td *ngIf="!isModal">{{ jobMatch.daysSinceOutreach }}</td>
                </tr>
            </tbody>

            <tbody *ngIf="!outreachObject.jobMatches || outreachObject.jobMatches.length == 0">
                <tr>
                    <td colspan="8" class="text-center">No Job Matches Found</td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #jobMatchModal let-modal="bsModalRef" let-data="data">

    <div class="modal-header">
        <h4 class="modal-title">
            <div class="alert alert-warning mb-0"><i class="fas fa-exclamation-triangle fa-fw fa-lg"></i><strong> Affected Jobs: Job(s) that no longer match</strong></div>
        </h4>
    </div>

    <div class="modal-body">
        <div class="row mx-2">
            <div class="col-xs-12 px-3">
                <p class="mb-4" *ngIf="!impactedOutreachObjectData.hasActiveJobs">
                    <span>Your profile will no longer be a match for the following jobs due to information in Candidate Contact and/or Candidate Additional Details. <br />
                        <b>Don't worry! We still have your profile and preference information and will use it to provide better matches to future job opportunities.</b>
                    </span>
                </p>
                <p class="mb-4" *ngIf="impactedOutreachObjectData.hasActiveJobs">
                    <span>While your changes to Candidate Contact and/or Candidate Additional Details match {{impactedOutreachObjectData.activeJobMatchCount}} job(s), your profile will no longer be a match for the following job(s)</span>
                </p>
                <p class="mb-4"><b>Do you still want to continue with those changes?</b></p>
            </div>
            <div class="px-1">
                <ng-container>
                    <ng-container *ngTemplateOutlet="jobMatchTableTemplate;
                            context: {
                              outreachObject: impactedOutreachObjectData,
                              isStaffingCompany: isStaffingCompany,
                              jobTypeList: jobTypeList,
                              salaryDurationOptions: salaryDurationOptions,
                              isModal: true
                            }">
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="modal-footer justify-content-end mr-2">
        <button type="button" class="btn btn-danger mr-2" (click)="onModalResponse(showJobMatchModal, false)">No</button>
        <button type="button" class="btn btn-info" (click)="onModalResponse(showJobMatchModal, true)">Yes</button>
    </div>
</ng-template>

<!-- Conflicts Modal -->
<ng-template #conflictsModal>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" aria-hidden="true" (click)="cancelConflicts()">×</button>
        <h4 class="modal-title wrap-text-in">Resolve Conflicts</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12 px-4">
                <p *ngIf="candidateConflictDetails?.conflictExists" class="text-danger">The existing contact details do
                    not
                    match the details in the Resume.</p>
                <p *ngIf="!candidateConflictDetails?.conflictExists">The existing contact details match the details in
                    the
                    Resume.</p>

                <span *ngIf="candidateConflictDetails?.additionalMatchRuleVerified">
                    <p *ngIf="candidateConflictDetails?.additionalMatchRuleVerificationPassed">
                        Additional matching criteria of education and experience have been verified.
                    </p>
                    <p class="text-danger" *ngIf="!candidateConflictDetails?.additionalMatchRuleVerificationPassed">
                        Additional matching criteria of education and/or experience do not match.
                    </p>
                </span>

                <p>Do you really want to update the Information with the details in the Resume?</p>
                <p>Please select the details to be updated.</p>

                <div class="col-xs-12">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th>Existing Details</th>
                                <th>Details in Resume</th>
                                <th>Details will be updated to:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let field of candidateConflictDetails?.candidateConflictDetails; let i = index">
                                <td class="text-center">{{i + 1}}.</td>
                                <td><span>{{field.fieldName}}</span></td>
                                <td>
                                    <div class="comp-management-radio pt-2" style="display:inline-block">
                                        <input type="radio" [name]="'conflict_' + i" [id]="'conflict_old_' + i" [value]="false"
                                            [(ngModel)]="field.newValueSelected" ngModelOptions="{standalone: true}"
                                            (change)="onConflictRadioChange(i, field.newValueSelected)">
                                        <label [for]="'conflict_old_' + i" class="compare-candidate-radio-label">{{field.oldValue}}</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="comp-management-radio pt-2" style="display:inline-block">
                                        <input type="radio" [name]="'conflict_' + i" [id]="'conflict_new_' + i" [value]="true"
                                            [(ngModel)]="field.newValueSelected" ngModelOptions="{standalone: true}"
                                            (change)="onConflictRadioChange(i, field.newValueSelected)">
                                        <label [for]="'conflict_new_' + i" class="compare-candidate-radio-label">{{field.newValue}}</label>
                                    </div>
                                </td>
                                <td>{{field.selectedValue}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-xs-12 text-right my-3">
                    <div class="clearfix">
                        <button type="button" class="btn btn-danger mr-2" (click)="cancelConflicts()">Cancel</button>
                        <button type="button" class="btn btn-success" (click)="saveConflicts()">Update</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-template>



